<script setup>
import { computed, useAttrs, watch } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
// NOTICE: KAPTION-INTEGRATION - partner-brand-themes.SIDEBAR.1-2
import {
  getBrandTheme,
  isKnownBrandTheme,
  storeBrandTheme,
} from 'dashboard/helper/kaptionBrandThemes';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');

// NOTICE: KAPTION-INTEGRATION - partner-brand-themes.SIDEBAR.1: the current
// account's theme (full account record, else the entry in the profile's
// accounts list that is there right after login). Rumo has no `mark`, so the
// installation logo below renders exactly as before.
const currentAccountId = useMapGetter('getCurrentAccountId');
const getAccount = useMapGetter('accounts/getAccount');
const currentUser = useMapGetter('getCurrentUser');
const accountBrandTheme = computed(() => {
  const id = currentAccountId.value;
  if (!id) return null;
  const account = getAccount.value?.(id);
  if (account?.brand_theme) return account.brand_theme;
  const entry = (currentUser.value?.accounts || []).find(a => a.id === id);
  return entry?.brand_theme || null;
});
const themeMark = computed(() => getBrandTheme(accountBrandTheme.value).mark);
const themeName = computed(() => getBrandTheme(accountBrandTheme.value).name);

// SIDEBAR.2: remember it so the next login page shows the same brand.
watch(
  accountBrandTheme,
  theme => {
    if (isKnownBrandTheme(theme)) storeBrandTheme(theme);
  },
  { immediate: true }
);
</script>

<template>
  <!-- NOTICE: KAPTION-INTEGRATION - partner-brand-themes.SIDEBAR.1 -->
  <template v-if="themeMark">
    <img
      v-bind="attrs"
      :src="themeMark.light"
      :alt="themeName"
      class="dark:hidden"
    />
    <img
      v-bind="attrs"
      :src="themeMark.dark"
      :alt="themeName"
      class="hidden dark:block"
    />
  </template>
  <!-- NOTICE: KAPTION-INTEGRATION - rumo-rebrand.IDENTITY.1: when a dark
       variant of the mark exists, swap it in under .dark (the site's dark
       palette uses a near-white bubble; the light mark vanishes on dark
       chrome). Falls back to the single thumbnail when no dark variant. -->
  <template
    v-else-if="globalConfig.logoThumbnail && globalConfig.logoThumbnailDark"
  >
    <img v-bind="attrs" :src="globalConfig.logoThumbnail" class="dark:hidden" />
    <img
      v-bind="attrs"
      :src="globalConfig.logoThumbnailDark"
      class="hidden dark:block"
    />
  </template>
  <img
    v-else-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#woot-logo-clip-2342424e23u32098)">
      <path
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill="#2781F6"
      />
      <path
        d="M11.4172 11.4172H7.70831C5.66383 11.4172 4 9.75328 4 7.70828C4 5.66394 5.66383 4 7.70835 4C9.75339 4 11.4172 5.66394 11.4172 7.70828V11.4172Z"
        fill="white"
        stroke="white"
        stroke-width="0.1875"
      />
    </g>
    <defs>
      <clipPath id="woot-logo-clip-2342424e23u32098">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
